export const AUDIT_LOGS_TEST_IDS = {
  filterByLabel: 'audit-logs-filter-by-label',
  filtersRow: 'audit-logs-filters-row',
  businessUnitInput: 'audit-logs-business-unit-input',
  businessUnitSelect: 'audit-logs-business-unit-select',
  startDateInput: 'audit-logs-start-date-input',
  endDateInput: 'audit-logs-end-date-input',
  refreshButton: 'audit-logs-refresh-button',
  viewingCount: 'audit-logs-viewing-count',
  table: 'audit-logs-table',
  emptyState: 'audit-logs-empty-state',
  loadMoreButton: 'audit-logs-load-more-button',
} as const;